import { components } from "@/api-schema";
import { commonColumns } from "./_constants/common-columns";

export type DepartmentTableType = components["schemas"]["Department"];

export const departmentTableDefaultColumns = {
  columnName: commonColumns.columnName<DepartmentTableType>(),
  columnDeletedAt: commonColumns.columnDeletedAt<DepartmentTableType>(),
  columnUuid: commonColumns.columnUuid<DepartmentTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<DepartmentTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<DepartmentTableType>(),
};
